<script>
// Tabla de reportes con grupos plegables (Centro de Costo > Concepto).
// Contrato: la vista define los computed `isCostCenterConceptoResult` y `tableItems`
// (filas con `group_key`), y usa `search` y `list` de GenericMixin.
export default {
  name: "CollapsibleGroupsMixin",
  data() {
    return {
      expanded_groups: [],
    };
  },
  computed: {
    groupKeys() {
      return this.isCostCenterConceptoResult && Array.isArray(this.list) ? [...new Set(this.tableItems.map((row) => row.group_key))] : [];
    },
    allExpanded() {
      return this.groupKeys.length > 0 && this.groupKeys.every((key) => this.expanded_groups.includes(key));
    },
    tableOptions() {
      return this.isCostCenterConceptoResult
        ? { descending: true, page: 1, itemsPerPage: -1, sortBy: [], sortDesc: [], groupBy: ["group_key"], groupDesc: [false] }
        : { descending: true, page: 1, itemsPerPage: 15, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [] };
    },
    buscando() {
      return !!(this.search && this.search.trim());
    },
  },
  methods: {
    sumValues(values) {
      return values.reduce((acc, value) => acc + (Math.round(parseFloat(value) * 100) || 0), 0) / 100;
    },
    isGroupOpen(group) {
      return this.buscando || this.expanded_groups.includes(group);
    },
    toggleGroup(group) {
      if (this.buscando) return;
      this.expanded_groups = this.expanded_groups.includes(group) ? this.expanded_groups.filter((key) => key !== group) : [...this.expanded_groups, group];
    },
    toggleAll() {
      this.expanded_groups = this.allExpanded ? [] : [...this.groupKeys];
    },
  },
};
</script>
